















import { Result } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ResultSlots } from '../../components.const';

@Component
export default class ResultTemplate extends Vue {
  private slotNames = ResultSlots;

  @Prop({ required: true })
  item: Result;
}
